import axios from "axios";
import {Dispatch} from "redux";
import {UpdateNotificationActionTypes, updateNotificationAction} from "../../../../types/admins/operators/admin/updateNotificationTypes";

export const updateNotificationDataResponce = (id:string, data: object): any => {
    return async (dispatch: Dispatch<updateNotificationAction>) => {
        try {
            dispatch({type: UpdateNotificationActionTypes.FETCH_UPDATE_NOTIFICATION_DATA});
            const response = await axios({
                method: 'patch',
                url: `/api/operators/${id}/sms_notification_settings`,
                data: data,
                withCredentials: false,
            });
            dispatch({type: UpdateNotificationActionTypes.FETCH_UPDATE_NOTIFICATION_DATA_SUCCESS, payload: response.data})
        } catch (error: any) {
            let errorMessage = 'Something went wrong. Please try again.';

            if (axios.isAxiosError(error) && error.response && error.response.data && error.response.data.detail) {
                errorMessage = error.response.data.detail.map((err: any) => err.msg).join(' ');
            } else if (axios.isAxiosError(error) && error.response && error.response.data && error.response.data.message) {
                errorMessage = error.response.data.message;
            } else if (error.message) {
                errorMessage = error.message;
            }
            dispatch({
                type: UpdateNotificationActionTypes.FETCH_UPDATE_NOTIFICATION_DATA_ERROR,
                payload: errorMessage
            });
        }
    }
}

export const clearStateNotificationUpdate = () => {

    return (dispatch: Dispatch<updateNotificationAction>) => {
        dispatch({
            type: UpdateNotificationActionTypes.CLEAR_STATE_UPDATE_NOTIFICATION_DATA_ERROR,
            payload: {}
        });
    };
};